<section class="otp_sec">
  <div class="otp_head">
    <h4>Sent OTP to test_user@gmail.com</h4>
    <h3>Do you want to change the number
      <a>Change ?</a>
    </h3>
  </div>
  <div class="otp_body">
    <!-- EMAIL-INPUT -->
    <div class="custom-form-group mobile-otp-group ">
      <label for="" class="custom-label">OTP Verification</label>
      <div class="custom-form-control">
        <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{length:5}"></ng-otp-input>
      </div>
    </div>
  </div>
  <div class="otp_footer">
    <button class="btn btn-sm otp_btn" mat-button routerLink="/index" (click)="dialogClose()"  >Login</button>
    <p>Didn't Receive OTP ?
      <a>Resend OTP</a>
    </p>
  </div>
</section>
